'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $("#advancedSearchMain", this).each(function () {
        $(this).find("button[type=submit]").each(function () {
            handleButton(this);
            $(this).click(function () {
                handleForm(this);
            });
        });
        $(this).find("input[class=form-control]").each(function () {
            handleEnter(this);
        });
    });
};

var _autoQueryHelper = require('linksoft/utils/auto-query-helper');

var $ = require("jquery");

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

function createArrayIfSingle(obj) {
    if (!obj) return obj;
    if (Object.prototype.toString.call(obj) === '[object Array]') {
        return obj;
    } else {
        return [obj];
    }
}

// handle form inputs and execute query
function handleForm(selector) {
    var obj = $('#AdvancedSearchForm').serializeObject();
    if (obj.ReleaseFrom) {
        var releaseFrom = $("#ReleaseFrom").data("DateTimePicker").date();
        if (releaseFrom) obj.ReleaseFrom = releaseFrom.format("YYYY-MM-DD");else obj.ReleaseFrom = "";
    }
    if (obj.ReleaseTo) {
        var releaseTo = $("#ReleaseTo").data("DateTimePicker").date();
        if (releaseTo) obj.ReleaseTo = releaseTo.format("YYYY-MM-DD");else obj.ReleaseTo = "";
    }
    obj.ProductTypesIds = createArrayIfSingle(obj.ProductTypesIds);
    obj.PublishersIds = createArrayIfSingle(obj.PublishersIds);
    obj.BrandsIds = createArrayIfSingle(obj.BrandsIds);
    obj.EditionsIds = createArrayIfSingle(obj.EditionsIds);
    obj.LanguagesIds = createArrayIfSingle(obj.LanguagesIds);
    obj.CategoriesIds = createArrayIfSingle(obj.CategoriesIds);
    (0, _autoQueryHelper.updateQuery)($(selector), obj);
}

// when hit enter then set the submit button and handle form data with query
function handleEnter(inputSelector) {
    $(inputSelector).on('keyup', function (e) {
        if (e.keyCode === 13) {
            var submitButton = $("button[type=submit]", "#advancedSearchMain");
            handleButton(submitButton);
            handleForm(submitButton);
        }
    });
}

// set the submit button 
function handleButton(buttonSelector) {
    $(buttonSelector).attr("data-filter", "true");
    $(buttonSelector).attr("data-query-target", "#mainContent");
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/advancedSearch.js
// module id = 922
// module chunks = 0